<template>
  <div class="card_collecting">
    <div class="qs_img">
      <img src="https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/coll_qs.png" alt />
    </div>
    <div class="qs_title">活动即将开启，敬请期待~</div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },

  methods: {},

  mounted() {},
};
</script>

<style scoped lang="scss">
.card_collecting {
  overflow: hidden;

  .qs_img {
    width: 370px;
    height: 272px;
    margin: 536px auto 0;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .qs_title {
    width: 100%;
    height: 31px;
    color: #a5a5a5;
    font-weight: 400;
    font-size: 22px;
    font-family: PingFangSC, PingFang SC, sans-serif;
    line-height: 31px;
    text-align: center;
  }
}
</style>
